export default "__VITE_ASSET__DTs00IZq__"